import React, { useState, useEffect } from "react";
import { useDispatch, useStore, useSelector } from "react-redux";
import ds from "../../../Services/DataServices";
import { useHistory } from "react-router";
import {
  Card,
  Table,
  Button,
  Row,
  Col,
  Spin,
  Breadcrumb,
  DatePicker,
  Modal,
  Form,
  Divider,
  message,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import { loadStockViewDetailsData } from "../../../appRedux/actions/CommonData";
import moment from "moment";
import { setCommonConfigs } from "../../../appRedux/actions/CommonData";
import { STOCK_LIST } from "../../../constants/Pages";
import {
  formatDigits,
  getDecryptID,
  StringIsNullOrEmpty,
} from "../../../appRedux/actions";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import { StockOrderTypesEnum } from "../../../constants/StockOrderTypesEnum";
import { StockOrderStatusTypesEnum } from "../../../constants/StockOrderStatusTypesEnum";
import ProductLink from "../../../components/ProductScreen/ProductLink";

const ViewStock = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const confirm = Modal.confirm;

  //#region Use Selector
  const getReduxStockDetails = useSelector(
    ({ commonConfigs }) => commonConfigs.getStockViewDetailsData
  );
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  );
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );
  const getIsTaxExclusive = useSelector(
    ({ MainSale }) => MainSale.getIsTaxExclusive
  );
  const defaultSalesTaxID = useSelector(
    ({ MainSale }) => MainSale.defaultSalesTaxID
  );

  //#endregion Use Selector

  //#region States
  const [getStatus, setgetStatus] = useState("");
  const [getOrderRefNumber, setgetOrderRefNumber] = useState("");
  const [getDataValues, setgetDataValues] = useState({
    createdAt: "",
    createdBy: "",
    deliverTo: "",
    supplierName: "",
    stockType: "",
  });
  const [getIsLoading, setIsLoading] = useState(true);
  const [getCreatedOn, setCreatedOn] = useState("");
  const [getCreatedBy, setCreatedBy] = useState("");
  const [getDeliverTo, setDeliverTo] = useState("");
  const [getSupplierName, setSupplierName] = useState("");
  const [getStockTypeName, setStockTypeName] = useState("");
  const [getStockTypeID, setStockTypeID] = useState("");
  const [getSupplierInvoice, setSupplierInvoice] = useState("");
  const [getOrderNo, setOrderNo] = useState("");
  const [getDeliveryDue, setDeliveryDue] = useState("");
  const [getStatusID, setStatusID] = useState("");
  const [getNote, setNote] = useState("");
  const [getSource, setSource] = useState("");
  const [getDestination, setDestination] = useState("");
  const [getProducts, setProducts] = useState([]);
  const [getIsShowDispatch, setIsShowDispatch] = useState(false);
  const [getIsDispatchModalVisible, setIsDispatchModalVisible] =
    useState(false);
  const [getIsSent, setIsSent] = useState(false);
  const [getCurrSymbol, setCurrSymbol] = useState("");
  const [getSourceName, setSourceName] = useState("");
  const [getDestinationName, setDestinationName] = useState("");
  const [saleTaxOptions, setSaleTaxOptions] = React.useState([
    { id: 1, label: "" },
  ]);
  const [getSalesGroupTaxes, setSalesGroupTaxes] = useState([]);

  //#endregion states end

  //#region Use Effect
  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      let commonData = getReduxCommonSetting;
      if (
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig &&
        commonData.storeCommonConfigs.storeConfig.currencyData
      ) {
        let currencyData =
          commonData.storeCommonConfigs.storeConfig.currencyData;
        setCurrSymbol(currencyData.currencySymbol);
        // setShortCurr(currencyData.currencyCode);
        // setCurrData(currencyData);
      }
    }

    return () => (mounted = false);
  }, [getReduxCommonSetting]);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      dispatch(setCommonConfigs(STOCK_LIST));
      const stockObj = {
        StockOrderID: match.params.id,
      };
      dispatch(loadStockViewDetailsData(stockObj, false));
    }

    return () => (mounted = false);
  }, []);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (
        getReduxStockDetails &&
        getReduxStockDetails.data &&
        getReduxStockDetails.data.data
      ) {
        setIsLoading(false);
        let res = getReduxStockDetails;
        let date = "";
        let dateDelivery = "";

        if (res.data.data.createdOn && res.data.data.createdOn != "") {
          date = res.data.data.createdOn;
        }

        if (res.data.data.deliveryDue && res.data.data.deliveryDue != "") {
          dateDelivery = res.data.data.deliveryDue;
        }

        let statusName =
          res.data.data.stockStatusTypeName != "" &&
          res.data.data.stockStatusTypeName
            ? res.data.data.stockStatusTypeName.toString().split(" ")[0]
            : "";
        let stockOrderTypeID =
          res.data.data.stockOrderTypeID != "" && res.data.data.stockOrderTypeID
            ? getDecryptID(res.data.data.stockOrderTypeID)
            : "";
        let number =
          res.data.data.orderNumber != null
            ? res.data.data.orderNumber
            : res.data.data.returnNumber;
        let stockOrderStatusTypeID =
          res.data.data.stockOrderStatusTypeID != "" &&
          res.data.data.stockOrderStatusTypeID
            ? getDecryptID(res.data.data.stockOrderStatusTypeID)
            : "";

        if (stockOrderTypeID == StockOrderTypesEnum.TransferStock) {
          number =
            res.data.data.referenceName != null
              ? res.data.data.referenceName
              : res.data.data.referenceName;
        }
        setgetStatus(statusName);
        setCreatedOn(date);
        setCreatedBy(res.data.data.createdBy);
        setStockTypeName(res.data.data.stockTypeName);
        setStockTypeID(stockOrderTypeID);
        setSupplierInvoice(res.data.data.supplierInvoiceNumber);
        setNote(res.data.data.notes);
        setDeliveryDue(dateDelivery);
        setOrderNo(number);
        setStatusID(stockOrderStatusTypeID);

        setSaleTaxOptions(res.data.data.salesTaxesOptions);
        setSalesGroupTaxes(res.data.data.salesGroupTaxes);

        let sourceName = "";
        let destinationName = "";
        let obj = res.data.data;

        if (
          stockOrderTypeID == StockOrderTypesEnum.OrderStock ||
          stockOrderTypeID == StockOrderTypesEnum.ReceiveStock
        ) {
          sourceName = obj.supplierName;
          destinationName = obj.deliverTo;
        }
        if (stockOrderTypeID == StockOrderTypesEnum.ReturnStock) {
          sourceName = obj.returnFrom;
          destinationName = obj.deliverTo;
        }
        if (stockOrderTypeID == StockOrderTypesEnum.TransferStock) {
          sourceName = obj.sourceOutletName;
          destinationName = obj.deliverTo;
        }
        setSourceName(sourceName);
        setDestinationName(destinationName);
        let stockOrderProducts =
          res.data.data.stockOrderDetailsProducts != undefined
            ? res.data.data.stockOrderDetailsProducts
            : [];
        stockOrderProducts =
          stockOrderProducts &&
          stockOrderProducts.map((e) => {
            let productName = e.isVariant
              ? `${e.productName} (${e.variantName})`
              : e.productName;

            let retailPrice = getIsTaxExclusive
              ? e.retailPrice != undefined
                ? parseFloat(e.retailPrice).toFixed(getDefaultDecimalPlaces)
                : "0.00"
              : DisplayPriceCalculator(
                  e.retailPrice,
                  e.productTaxID,
                  res.data.data.salesTaxesOptions,
                  res.data.data.salesGroupTaxes
                );
            return {
              productName: productName,
              orderedQty: e.orderedQty,
              productID: e.productID,
              receivedQty: e.receivedQty,
              retailPrice: retailPrice,
              returnedQty: e.returnedQty,
              sku: e.sku,
              stockAtSource: e.stockAtSource,
              stockOnHand: e.stockOnHand,
              supplierCode: e.supplierCode,
              supplyPrice: e.supplyPrice,
              totalRetailPrice:
                stockOrderStatusTypeID ==
                StockOrderStatusTypesEnum.ReceivedOrders
                  ? e.receivedQty * retailPrice
                  : e.orderedQty * retailPrice,
              totalSupplyPrice:
                stockOrderStatusTypeID ==
                StockOrderStatusTypesEnum.ReceivedOrders
                  ? e.receivedQty * e.supplyPrice
                  : e.totalSupplyPrice,
              isProductInventory: e.isProductInventory,
              isVariant: e.isVariant,
              parentProductID: e.parentProductID,
            };
          });
        setProducts(stockOrderProducts);
        // setProducts(res.data.data.stockOrderDetailsProducts);
      } else {
        if (
          (getReduxStockDetails &&
            getReduxStockDetails.res &&
            getReduxStockDetails.res == "Failed") ||
          (getReduxStockDetails &&
            getReduxStockDetails.data &&
            !getReduxStockDetails.data.data)
        ) {
          setIsLoading(false);
          dispatch(loadStockViewDetailsData("", true));
        }
      }
    }

    return () => (mounted = false);
  }, [getReduxStockDetails]);
  //#endregion Use Effect

  //#region API

  async function postStockOrderStatusUpdate(body) {
    await ds
      .postStockOrderStatus(body, BEHAVIOUR_TYPE.UPDATE)
      .then((res) => {
        setIsLoading(false);
        if (res.data.data) {
          setStatusID(body.StockOrderStatusID);
          message.success("Status Updated Successfully");
          window.location.reload();
          //history.push("/Dashboard/inventory/stockcontrol/stockcontrollist");
        } else {
          message.info("Failed, kindly report & try later");
        }
      })
      .catch((error) => {
        // ;
        message.error("Something went wrong...");
        setIsLoading(false);
      });
  }

  //#endregion API

  //#region Custom Functions
  function onReceiveClick() {
    history.push(
      `/Dashboard/inventory/stockcontrol/edit/${match.params.id}/true`
    );
  }

  function onDispatchClick() {
    setIsDispatchModalVisible(true);
    setIsShowDispatch(true);
  }
  function onSentClick() {
    setIsDispatchModalVisible(true);
    setIsSent(true);
  }

  function onCancelClick() {
    setIsLoading(true);
    let body = {
      StockOrderID: match.params.id,
      StockOrderStatusID: StockOrderStatusTypesEnum.CancelledOrders, //Cancel
    };
    postStockOrderStatusUpdate(body);
  }

  function showDeleteConfirm() {
    confirm({
      title: <h2>{"Are you sure?"}</h2>,
      content: `You are about to perform an action that can't be undone.`,
      okText: "Yes",
      cancelText: "No",
      okButtonProps: { className: "dk-btn-add close-reg-btn" },
      cancelButtonProps: { className: "dk-btn-cancel close-reg-btn" },
      onOk() {
        onCancelClick();
      },
      onCancel() {
        //console.log('Cancel');
      },
    });
  }

  function DisplayPriceCalculator(
    retailPrice,
    productTaxID,
    pSalesTaxes,
    pSalesGroupTaxes
  ) {
    let finalRetailPrice =
      retailPrice != null && retailPrice != undefined && retailPrice != ""
        ? parseFloat(retailPrice)
        : 0;

    const getTotalTaxData = GetCummulativeTaxDatabyTaxID(
      productTaxID,
      pSalesTaxes,
      pSalesGroupTaxes
    );
    if (!getIsTaxExclusive) {
      if (finalRetailPrice != 0) {
        if (getTotalTaxData) {
          let totalTaxPercentage = getTotalTaxData.totalTaxPercentage / 100;
          //  finalRetailPrice +=getTotalTaxData.totalFixedTax;
          let inclusiveRetailPrice =
            finalRetailPrice * totalTaxPercentage +
            finalRetailPrice +
            getTotalTaxData.totalFixedTax;
          finalRetailPrice = parseFloat(inclusiveRetailPrice).toFixed(
            getDefaultDecimalPlaces
          );
        }
      }
    }
    return finalRetailPrice;
  }
  const GetCummulativeTaxDatabyTaxID = (
    paramTaxID,
    paramSalesTaxes,
    paramSalesGroupTaxes
  ) => {
    let taxID = paramTaxID.includes("&")
      ? getDecryptID(paramTaxID).toString()
      : paramTaxID.toString();
    if (taxID == "0") {
      taxID = defaultSalesTaxID;
    }

    let totalTaxPercentage = 0;
    let totalFixedTax = 0;
    const currentTax =
      paramSalesTaxes && paramSalesTaxes.filter((x) => x.id == taxID)[0];
    if (currentTax) {
      if (currentTax.isGroup) {
        const currentGroupTax =
          paramSalesGroupTaxes &&
          paramSalesGroupTaxes.filter(
            (x) => getDecryptID(x.groupID) == taxID
          )[0];
        if (currentGroupTax) {
          currentGroupTax.taxes &&
            currentGroupTax.taxes.map((x) => {
              if (x.isFix) {
                totalFixedTax += x.salesTaxValue;
              } else {
                totalTaxPercentage += x.salesTaxValue;
              }
            });
        }
      } else {
        if (currentTax.isFix) {
          totalFixedTax = currentTax.taxPercentage;
        } else {
          totalTaxPercentage = currentTax.taxPercentage;
        }
      }
    }
    const totalTaxValue = {
      totalTaxPercentage: parseFloat(totalTaxPercentage),
      totalFixedTax: parseFloat(totalFixedTax),
    };
    return totalTaxValue;
  };
  const GetTotalFooterData = ({ pageData, stockType }) => {
    let returnedQty1 = 0,
      totalRetailPrice1 = 0,
      retailPrice1 = 0,
      totalSupplyPrice1 = 0,
      supplyPrice1 = 0,
      receivedQty1 = 0,
      orderedQty1 = 0;
    pageData &&
      pageData.forEach(
        ({
          returnedQty,
          totalRetailPrice,
          retailPrice,
          totalSupplyPrice,
          supplyPrice,
          receivedQty,
          orderedQty,
        }) => {
          returnedQty1 += parseInt(returnedQty);
          totalRetailPrice1 += parseFloat(totalRetailPrice);
          retailPrice1 += parseFloat(retailPrice);
          totalSupplyPrice1 += parseFloat(totalSupplyPrice);
          supplyPrice1 += parseFloat(supplyPrice);
          receivedQty1 += parseInt(receivedQty);
          orderedQty1 += parseInt(orderedQty);
        }
      );

    const myComponents = {
      OrderStock: (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
          <Table.Summary.Cell index={1}></Table.Summary.Cell>
          <Table.Summary.Cell index={2}></Table.Summary.Cell>
          <Table.Summary.Cell index={3}></Table.Summary.Cell>
          <Table.Summary.Cell index={4}>
            <p>{orderedQty1} </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5}>
            <p>{receivedQty1}</p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p>
              {getCurrSymbol}
              {formatDigits(supplyPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <p>
              {getCurrSymbol}
              {formatDigits(totalSupplyPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <p>
              {getCurrSymbol}
              {formatDigits(retailPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9}>
            <p>
              {getCurrSymbol}
              {formatDigits(totalRetailPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      ),
      ReceiveStock: (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
          <Table.Summary.Cell index={1}></Table.Summary.Cell>
          <Table.Summary.Cell index={2}></Table.Summary.Cell>
          <Table.Summary.Cell index={3}></Table.Summary.Cell>
          <Table.Summary.Cell index={4}>
            <p>{orderedQty1} </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5}>
            <p>{receivedQty1}</p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p>
              {getCurrSymbol}
              {formatDigits(supplyPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <p>
              {getCurrSymbol}
              {formatDigits(totalSupplyPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <p>
              {getCurrSymbol}
              {formatDigits(retailPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9}>
            <p>
              {getCurrSymbol}
              {formatDigits(totalRetailPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      ),
      TransferStock: (
        <Table.Summary.Row style={{ fontWeight: 700 }}>
          <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
          <Table.Summary.Cell index={1}></Table.Summary.Cell>
          <Table.Summary.Cell index={2}></Table.Summary.Cell>
          <Table.Summary.Cell index={3}></Table.Summary.Cell>
          <Table.Summary.Cell index={4}></Table.Summary.Cell>
          <Table.Summary.Cell index={5}>
            <p>{orderedQty1} </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p>{receivedQty1}</p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <p>
              {getCurrSymbol}
              {formatDigits(supplyPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <p>
              {getCurrSymbol}
              {formatDigits(totalSupplyPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={9}>
            <p>
              {getCurrSymbol}
              {formatDigits(retailPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={10}>
            <p>
              {getCurrSymbol}
              {formatDigits(totalRetailPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      ),
      ReturnStock: (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
          <Table.Summary.Cell index={1}></Table.Summary.Cell>
          <Table.Summary.Cell index={2}></Table.Summary.Cell>
          <Table.Summary.Cell index={3}></Table.Summary.Cell>
          <Table.Summary.Cell index={4}>
            <p>{returnedQty1} </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={5}>
            <p>
              {" "}
              {getCurrSymbol}
              {formatDigits(supplyPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={6}>
            <p>
              {getCurrSymbol}
              {formatDigits(totalSupplyPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={7}>
            <p>
              {getCurrSymbol}
              {formatDigits(retailPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
          <Table.Summary.Cell index={8}>
            <p>
              {getCurrSymbol}
              {formatDigits(totalRetailPrice1, getDefaultDecimalPlaces)}
            </p>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      ),
    };

    return myComponents[stockType];
  };

  //#endregion Custom Functions End

  //#region Columns
  const columnsOrdered = [
    {
      title: "Product",
      width: 100,
      dataIndex: "productName",
      key: "productName",
      fixed: "left",
      render: (text, record) => {
        let pID = record.isVariant ? record.parentProductID : record.productID;
        return <ProductLink ProductId={pID} text={text} />;
      },
    },
    { title: "SKU", dataIndex: "sku", key: "sku", width: 100 },
    {
      title: "Supplier Code",
      dataIndex: "supplierCode",
      key: "supplierCode",
      width: 100,
    },
    {
      title: "Stock",
      dataIndex: "stockOnHand",
      key: "stockOnHand",
      width: 100,
      render: (text, record) => {
        let count = text;
        return <span>{record.isProductInventory ? count : "∞"}</span>;
      },
    },
    {
      title: "Ordered",
      dataIndex: "orderedQty",
      key: "orderedQty",
      width: 100,
    },
    {
      title: "Received",
      dataIndex: "receivedQty",
      key: "receivedQty",
      width: 100,
    },
    {
      title: "Supply Cost",
      dataIndex: "supplyPrice",
      key: "supplyPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${getCurrSymbol}${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}`}</p>
        );
      },
    },
    {
      title: "Total Supply Cost",
      dataIndex: "totalSupplyPrice",
      key: "totalSupplyPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${getCurrSymbol}${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}`}</p>
        );
      },
    },
    {
      title: "Retail Cost",
      dataIndex: "retailPrice",
      key: "retailPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${getCurrSymbol}${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}`}</p>
        );
      },
    },
    {
      title: "Total Retail Cost",
      dataIndex: "totalRetailPrice",
      key: "totalRetailPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${getCurrSymbol}${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}`}</p>
        );
      },
    },
  ];
  const columnsReturned = [
    {
      title: "Product",
      width: 100,
      dataIndex: "productName",
      key: "productName",
      fixed: "left",
      render: (text, record) => {
        let pID = record.isVariant ? record.parentProductID : record.productID;
        return <ProductLink ProductId={pID} text={text} />;
      },
    },
    { title: "SKU", dataIndex: "sku", key: "sku", width: 100 },
    {
      title: "Supplier Code",
      dataIndex: "supplierCode",
      key: "supplierCode",
      width: 100,
    },
    {
      title: "Stock",
      dataIndex: "stockOnHand",
      key: "stockOnHand",
      width: 100,
      render: (text, record) => {
        let count = text;
        return <span>{record.isProductInventory ? count : "∞"}</span>;
      },
    },
    {
      title: "Returned",
      dataIndex: "returnedQty",
      key: "returnedQty",
      width: 100,
    },
    {
      title: "Supply Cost",
      dataIndex: "supplyPrice",
      key: "supplyPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${getCurrSymbol}${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}`}</p>
        );
      },
    },
    {
      title: "Total Supply Cost",
      dataIndex: "totalSupplyPrice",
      key: "totalSupplyPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${getCurrSymbol}${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}`}</p>
        );
      },
    },
    {
      title: "Retail Cost",
      dataIndex: "retailPrice",
      key: "retailPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${getCurrSymbol}${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}`}</p>
        );
      },
    },
    {
      title: "Total Retail Cost",
      dataIndex: "totalRetailPrice",
      key: "totalRetailPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${getCurrSymbol}${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}`}</p>
        );
      },
    },
  ];
  const columnsTransfered = [
    {
      title: "Product",
      width: 100,
      dataIndex: "productName",
      key: "productName",
      fixed: "left",
      render: (text, record) => {
        let pID = record.isVariant ? record.parentProductID : record.productID;
        return <ProductLink ProductId={pID} text={text} />;
      },
    },
    { title: "SKU", dataIndex: "sku", key: "sku", width: 100 },
    {
      title: "Supplier Code",
      dataIndex: "supplierCode",
      key: "supplierCode",
      width: 100,
    },
    {
      title: "Stock in hand",
      dataIndex: "stockOnHand",
      key: "stockOnHand",
      width: 100,
      render: (text, record) => {
        let count = text;
        return <span>{record.isProductInventory ? count : "∞"}</span>;
      },
    },
    {
      title: "Stock at source",
      dataIndex: "stockAtSource",
      key: "stockAtSource",
      width: 100,
      render: (text, record) => {
        let count = text;
        return <span>{record.isProductInventory ? count : "∞"}</span>;
      },
    },
    {
      title: "Ordered",
      dataIndex: "orderedQty",
      key: "orderedQty",
      width: 100,
    },
    {
      title: "Received",
      dataIndex: "receivedQty",
      key: "receivedQty",
      width: 100,
    },
    {
      title: "Supply Cost",
      dataIndex: "supplyPrice",
      key: "supplyPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}${getCurrSymbol}`}</p>
        );
      },
    },
    {
      title: "Total Supply Cost",
      dataIndex: "totalSupplyPrice",
      key: "totalSupplyPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}${getCurrSymbol}`}</p>
        );
      },
    },
    {
      title: "Retail Cost",
      dataIndex: "retailPrice",
      key: "retailPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}${getCurrSymbol}`}</p>
        );
      },
    },
    {
      title: "Total Retail Cost",
      dataIndex: "totalRetailPrice",
      key: "totalRetailPrice",
      width: 100,
      render: (text, record) => {
        let final = text ? parseFloat(text).toFixed(2) : "0.00";
        return (
          <p>{`${formatDigits(
            final,
            getDefaultDecimalPlaces
          )}${getCurrSymbol}`}</p>
        );
      },
    },
  ];
  //#endregion Columns

  const DispatchModal = (props) => {
    const name = props.name ? props.name : "";
    const [getIsDateKnow, setIsDateKnow] = useState(false);
    const [isClickNext, setIsClickNext] = useState(false);
    const [getPostBody, setPostBody] = useState({});

    const onFinishDispatch = (values) => {
      let body = {
        StockOrderID: match.params.id,
        DeliveryDate: moment(form.getFieldValue("DispatchDate")),
        StockOrderStatusID: StockOrderStatusTypesEnum.DispatchedOrders, //dispatch
      };
      setPostBody(body);
      setIsClickNext(true);
    };
    const onFinishFailed = (errorInfo) => {
      message.error(
        "Kindly provide date or click on above card about don't know",
        4
      );
    };
    function onMarkDispacthed() {
      setIsLoading(true);
      setIsShowDispatch(false);
      setIsDispatchModalVisible(false);
      postStockOrderStatusUpdate(getPostBody);
      setPostBody({});
    }
    function onMarkSentClick() {
      setIsLoading(true);
      setIsShowDispatch(false);
      setIsSent(false);
      let body = {
        StockOrderID: match.params.id,
        StockOrderStatusID:
          getStockTypeID.toString() == StockOrderTypesEnum.ReturnStock
            ? StockOrderStatusTypesEnum.SentReturns
            : StockOrderStatusTypesEnum.SentOrders, //sent
        DeliveryDate: null,
      };
      postStockOrderStatusUpdate(body);
      setPostBody({});
    }
    return (
      <Modal
        className="Mark-as-Sent-Modal"
        visible={getIsDispatchModalVisible}
        onCancel={() => {
          setIsDispatchModalVisible(false);
          setIsSent(false);
          setIsShowDispatch(false);
        }}
        centered={true}
        width={"800px"}
        title={
          <strong>
            {getIsSent ? (
              <IntlMessages id="stock.view.marksent" />
            ) : (
              <IntlMessages id="stock.view.markdispatch" />
            )}
          </strong>
        }
        footer={
          <>
            {/* {!getIsSent && (
              <Button
                className=""
                type="primary"
                onClick={() => setIsClickNext(false)}
              >
                <IntlMessages id="stock.view.back" />
              </Button>
            )}

            {getIsSent ? (
              <Button
                className=""
                type="primary"
                onClick={() => onMarkSentClick()}
              >
                <IntlMessages id="stock.view.marksent" />
              </Button>
            ) : (
              <Button
                className=""
                type="primary"
                onClick={() => onMarkDispacthed()}
              >
                <IntlMessages id="stock.view.markdispatch" />
              </Button>
            )} */}

            {getIsShowDispatch ? (
              isClickNext ? (
                <Button
                  className=""
                  type="primary"
                  onClick={() => setIsClickNext(false)}
                >
                  <IntlMessages id="stock.view.back" />
                </Button>
              ) : (
                <Button
                  className=""
                  type="primary"
                  onClick={() => onFinishDispatch({})}
                >
                  <IntlMessages id="stock.view.next" />
                </Button>
              )
            ) : (
              <Button
                className=""
                type="primary"
                onClick={() => onMarkSentClick()}
              >
                <IntlMessages id="stock.view.marksent" />
              </Button>
            )}

            {getIsShowDispatch && isClickNext ? (
              <>
                {" "}
                <Button
                  className=""
                  type="primary"
                  onClick={() => onMarkDispacthed()}
                >
                  <IntlMessages id="stock.view.markdispatch" />
                </Button>
              </>
            ) : (
              ""
            )}
          </>
        }
      >
        {isClickNext || getIsSent ? (
          <div className="Sent">
            {getIsSent ? (
              <h2>
                <IntlMessages
                  id="stock.view.sentdet"
                  values={{
                    strong: (chunks) => <strong>{chunks}</strong>,
                    title: name,
                  }}
                />
              </h2>
            ) : (
              <h2>
                <IntlMessages
                  id="stock.view.despadet"
                  values={{
                    strong: (chunks) => <strong>{chunks}</strong>,
                    title: name,
                  }}
                />
              </h2>
            )}

            {getIsSent ? (
              <p>
                <IntlMessages id="stock.view.sentdetonce" />
              </p>
            ) : (
              <p>
                <IntlMessages id="stock.view.dispdetonce" />
              </p>
            )}
          </div>
        ) : (
          <div className="Dispatched">
            <h2>
              <IntlMessages
                id="stock.view.endear"
                values={{
                  strong: (chunks) => <strong>{chunks}</strong>,
                  title: name,
                }}
              />
            </h2>

            <p>
              <IntlMessages id="products.promotionlisting.endearlypopupdesc1" />
            </p>

            <Row className="dk-flex-promo">
              <Col lg={12} md={12} sm={12} xs={24} className="dk-flex-promo-1">
                <div className="dk-custom-promoadd-card1 dk-flex-promo-1">
                  <Card
                    className={`${
                      getIsDateKnow ? "ant-card-bordered-active" : ""
                    }`}
                    onClick={() => setIsDateKnow(true)}
                  >
                    <h3>
                      <IntlMessages id="stock.view.iknow" />
                    </h3>

                    <Divider className="mt-3 mb-4" />

                    <p className="mb-0">
                      <IntlMessages id="stock.view.iknowdet" />
                    </p>
                  </Card>
                </div>
              </Col>

              <Col lg={12} md={12} sm={12} xs={24} className="dk-flex-promo-1">
                <div className="dk-custom-promoadd-card1 dk-flex-promo-1">
                  <Card
                    className={`${
                      !getIsDateKnow ? "ant-card-bordered-active" : ""
                    }`}
                    onClick={() => setIsDateKnow(false)}
                  >
                    <h3>
                      <IntlMessages id="stock.view.idont" />
                    </h3>

                    <Divider className="mt-3 mb-4" />

                    <p className="mb-0">
                      <IntlMessages id="stock.view.idontdet" />
                    </p>
                  </Card>
                </div>
              </Col>
            </Row>

            {getIsDateKnow ? (
              <>
                <Row>
                  <Col lg={24} md={24} sm={24} xs={24}>
                    <label>
                      <IntlMessages id="stock.add.deldate" />:
                    </label>
                    <Form
                      name="DispatchForm"
                      form={form}
                      scrollToFirstError
                      initialValues={{
                        DispatchDate: moment(getDeliveryDue),
                      }}
                    >
                      <Form.Item
                        className="ant-form-item-label-custom ant-form-margin-right  ant-form-custom-alignment"
                        name="DispatchDate"
                        rules={[
                          {
                            required: true,
                            message: (
                              <IntlMessages id="products.promoadd.disperalert" />
                            ),
                          },
                        ]}
                      >
                        <DatePicker
                          className="w-100"
                          size="large"
                          inputReadOnly={true}
                          format={"DD MMMM  YYYY"}
                        />
                      </Form.Item>
                    </Form>
                  </Col>
                </Row>
              </>
            ) : (
              ""
            )}
          </div>
        )}
      </Modal>
    );
  };

  return (
    <Spin
      tip={<IntlMessages id="sell.cashlisting.cashloading" />}
      spinning={getIsLoading}
      size="large"
    >
      <div className="Content-wrapper">
        <Row>
          <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            <DispatchModal name={getOrderNo} />
            <Breadcrumb separator=">">
              <Breadcrumb.Item>
                <span>
                  <IntlMessages id="discount.inventory" />
                </span>
              </Breadcrumb.Item>
              <Breadcrumb.Item
                className="custom-stock-hoverbreadcrumb"
                onClick={() =>
                  history.push("/Dashboard/inventory/stockcontrol")
                }
              >
                <span>
                  <IntlMessages id="stock.edit.stockcont" />
                </span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>
                  <IntlMessages id="stock.view.viewdet" />
                </span>
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>

          <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            {getStockTypeID != StockOrderTypesEnum.ReceiveStock &&
              getStatusID != StockOrderStatusTypesEnum.ReceivedOrders &&
              getStatusID != StockOrderStatusTypesEnum.CancelledOrders && (
                <div className="pg-header-btn mt-10-md View-stockControll-btn">
                  {(getStockTypeID == StockOrderTypesEnum.OrderStock ||
                    getStockTypeID == StockOrderTypesEnum.TransferStock ||
                    (getStatusID == StockOrderStatusTypesEnum.OpenReturns &&
                      getStockTypeID == StockOrderTypesEnum.ReturnStock)) && (
                    <Button
                      className=""
                      type="primary"
                      onClick={() => {
                        if (match.params.id) {
                          history.push(
                            `/Dashboard/inventory/stockcontrol/edit/${match.params.id}/false`
                          );
                        }
                      }}
                    >
                      <IntlMessages id="stock.view.editdet" />
                    </Button>
                  )}

                  {getStockTypeID != StockOrderTypesEnum.ReceiveStock &&
                    getStatusID != StockOrderStatusTypesEnum.SentOrders &&
                    getStatusID != StockOrderStatusTypesEnum.DispatchedOrders &&
                    getStatusID != StockOrderStatusTypesEnum.SentReturns && (
                      <Button
                        className=""
                        type="primary"
                        onClick={() => {
                          onSentClick();
                        }}
                      >
                        <IntlMessages id="stock.view.marksent" />
                      </Button>
                    )}

                  {getStockTypeID == StockOrderTypesEnum.OrderStock && (
                    <Button
                      className=""
                      type="primary"
                      onClick={() => {
                        onReceiveClick();
                      }}
                    >
                      <IntlMessages id="stock.view.rec" />
                    </Button>
                  )}

                  {getStockTypeID == StockOrderTypesEnum.TransferStock &&
                    getStatusID == StockOrderStatusTypesEnum.SentOrders && (
                      <Button
                        className=""
                        type="primary"
                        onClick={() => {
                          onReceiveClick();
                        }}
                      >
                        <IntlMessages id="stock.view.rec" />
                      </Button>
                    )}
                  {getStockTypeID == StockOrderTypesEnum.OrderStock &&
                    getStatusID !=
                      StockOrderStatusTypesEnum.DispatchedOrders && (
                      <Button
                        className=""
                        type="primary"
                        onClick={() => {
                          onDispatchClick();
                        }}
                      >
                        <IntlMessages id="stock.view.markdispatch" />
                      </Button>
                    )}

                  {getStockTypeID != StockOrderTypesEnum.ReceiveStock &&
                    getStatusID != StockOrderStatusTypesEnum.SentReturns && (
                      <Button
                        className=""
                        type="primary"
                        onClick={() => {
                          showDeleteConfirm();
                        }}
                        style={
                          {
                            //   backgroundColor: "rgb(215, 113, 115)",
                            //   borderColor: "rgb(215, 113, 115)",
                          }
                        }
                      >
                        <IntlMessages id="stock.view.canorder" />
                      </Button>
                    )}
                </div>
              )}
          </Col>
        </Row>

        <Row className="mt-3 mb-4">
          <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            <Card
              className="gx-card"
              title={
                <>
                  <h2 className="mb-0 mt-3">
                    {!StringIsNullOrEmpty(getOrderNo) ? getOrderNo : "--"}
                  </h2>
                  <p className="mb-0">{`(${getStatus})`}</p>
                </>
              }
            >
              <div className="dk-last-closer-main Register-Summary-Div View-Stock-div">
                <div className="dk-reg-closing">
                  <h3
                    className="dk-reg-closing-flex"
                    style={{ color: "#6692b0" }}
                  >
                    {getStockTypeID == StockOrderTypesEnum.OrderStock ||
                    getStockTypeID == StockOrderTypesEnum.ReturnStock ? (
                      <>
                        <IntlMessages id="stock.add.supp" />:
                      </>
                    ) : getStockTypeID == StockOrderTypesEnum.TransferStock ? (
                      <>
                        <IntlMessages id="stock.edit.spurceout" />;
                      </>
                    ) : (
                      <>
                        <IntlMessages id="stock.view.ordrfrom" />:
                      </>
                    )}
                  </h3>
                  <p>{`${
                    getStockTypeID == StockOrderTypesEnum.ReturnStock
                      ? getDestinationName
                      : getSourceName
                  }`}</p>
                </div>

                <div className="dk-reg-closing">
                  <h3
                    className="dk-reg-closing-flex"
                    style={{ color: "#6692b0" }}
                  >
                    {getStockTypeID == StockOrderTypesEnum.ReturnStock ? (
                      <>
                        <IntlMessages id="stock.view.returnfrom" />:
                      </>
                    ) : (
                      <>
                        <IntlMessages id="stock.add.delto" />:
                      </>
                    )}
                  </h3>
                  <p>
                    {getStockTypeID == StockOrderTypesEnum.ReturnStock
                      ? getSourceName
                      : getDestinationName}
                  </p>
                </div>

                {getStockTypeID != StockOrderTypesEnum.TransferStock &&
                  !StringIsNullOrEmpty(getSupplierInvoice) && (
                    <div className="dk-reg-closing">
                      <h3
                        className="dk-reg-closing-flex"
                        style={{ color: "#6692b0" }}
                      >
                        <IntlMessages id="stock.edit.suppinvo" />:
                      </h3>
                      <p>{getSupplierInvoice}</p>
                    </div>
                  )}

                {(getStockTypeID == StockOrderTypesEnum.OrderStock ||
                  getStockTypeID == StockOrderTypesEnum.ReceiveStock) &&
                  !StringIsNullOrEmpty(getNote) && (
                    <div className="dk-reg-closing">
                      <h3
                        className="dk-reg-closing-flex"
                        style={{ color: "#6692b0" }}
                      >
                        <IntlMessages id="stock.add.note" />:
                      </h3>
                      <p>{getNote}</p>
                    </div>
                  )}

                <div className="dk-reg-closing">
                  <h3
                    className="dk-reg-closing-flex"
                    style={{ color: "#6692b0" }}
                  >
                    <IntlMessages id="stock.view.createdon" />:
                  </h3>
                  <p>{moment(getCreatedOn).format("MMM D, YYYY")}</p>
                </div>

                <div className="dk-reg-closing">
                  <h3
                    className="dk-reg-closing-flex"
                    style={{ color: "#6692b0" }}
                  >
                    <IntlMessages id="stock.view.createdby" />:
                  </h3>

                  <p>{getCreatedBy}</p>
                </div>

                <div className="dk-reg-closing">
                  <h3
                    className="dk-reg-closing-flex"
                    style={{ color: "#6692b0" }}
                  >
                    <IntlMessages id="stock.edit.deliverdue" />:
                  </h3>
                  <p>{moment(getDeliveryDue).format("MMM D, YYYY")}</p>
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        <Row style={{ marginTop: -16, marginBottom: 10 }}>
          <Col md={24}>
            <Table
              class="gx-table-responsive custom-product-table"
              columns={
                getStockTypeID == StockOrderTypesEnum.TransferStock
                  ? columnsTransfered
                  : getStockTypeID == StockOrderTypesEnum.ReturnStock
                  ? columnsReturned
                  : columnsOrdered
              }
              dataSource={
                getProducts && getProducts.length > 0 ? getProducts : []
              }
              scroll={{ x: 1800 }}
              summary={(pageData) => {
                return (
                  <>
                    <GetTotalFooterData
                      pageData={pageData}
                      stockType={
                        getStockTypeID == StockOrderTypesEnum.TransferStock
                          ? "TransferStock"
                          : getStockTypeID == StockOrderTypesEnum.ReturnStock
                          ? "ReturnStock"
                          : "OrderStock"
                      }
                    />
                  </>
                );
              }}
            ></Table>
          </Col>
        </Row>
      </div>
    </Spin>
  );
};
export default ViewStock;
